import { gql } from "graphql-request";

const SERVER_DELETE_COST_CENTER_GROUP_NODE = gql`
  mutation SERVER_DeleteCostCenterGroupNode($id: ID!) {
  deleteHierarchyNode(id: $id)
}
`;
export default SERVER_DELETE_COST_CENTER_GROUP_NODE;
